import { NgClass } from '@angular/common';
import { Component, OnInit, inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from './shared/services/config.service';
import { LocaleSessionService } from './shared/services/localeSession.service';
import { LayoutService } from './layout/layout.service';
import { CheckCookiesSupportComponent } from './shared/app-support/check-cookies-support/check-cookies-support.component';
import { RouterOutlet } from '@angular/router';
import { DebugComponent } from './shared/app-support/debug/debug.component';
import { SignupHandlerService } from './signup/signup-handler.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, RouterOutlet, CheckCookiesSupportComponent, DebugComponent],
})
export class AppComponent implements OnInit {
  private doc = inject<Document>(DOCUMENT);
  private localeSessionService = inject(LocaleSessionService);
  private layoutService = inject(LayoutService);
  private signUpService = inject(SignupHandlerService);

  title = 'profile-module';

  theme: string;

  ngOnInit() {
    const oemId = ConfigService.getIdConfig();
    this.doc
      .getElementById('appFavicon')
      .setAttribute('href', `../assets-common/${oemId}/favicon.ico`);
    this.theme = `${oemId}-theme`;
    this.loadOemTheme(this.theme);
    this.localeSessionService.languageLoaded$.subscribe({
      next: () => {
        this.layoutService.languageSet = true;
      },
    });
    // this.dictionaryService.getLanguageList().subscribe(() => {
    // this.localeSessionService.checkLangExistence();
    // console.log('ok');
    // this.layoutService.languageSet = true;
    // });
    // trackMousePosInCss();
  }

  private loadOemTheme(themeName: string) {
    const headEl = this.doc.getElementsByTagName('head')[0];

    const newLinkEl = this.doc.createElement('link');

    newLinkEl.rel = 'stylesheet';
    newLinkEl.href = `${themeName}.css`;

    headEl.appendChild(newLinkEl);
  }
}
